<template>
<v-list-item  @click="resetUser" v-bind="$attrs" class="pr-0">

<slot>
<v-list-item-avatar v-if="!dense && user && user.avatar" :color="color">
      <v-img :src="user.avatar"></v-img>
  </v-list-item-avatar>
<v-list-item-icon v-else-if="icon" class="mr-3">
      <v-icon :color="color" v-text="icon"></v-icon></v-list-item-icon>
 <v-list-item-content>
                <v-list-item-title class="justify-center">
                <span v-if="isValid && user">{{user.name ? user.name : user.phone}}</span>
    <otp-input v-else  ref="otpInput" :length="10" :autofocus="true"
              v-model="phone" color="primary" @finish="check" style="max-width:400px"
              ></otp-input>

    <!--v-text-field class="pa-0 ma-0"
            v-model="phone" ref="phonefield"
            type="number" :placeholder="placeholder"
            :rules="[$config.rules.required, $config.rules.mobile]"
            :label="user ? null : 'Telefoonnummer'" autofocus
            hide-details="" validate-on-blur
            @input="check" @blur="blur"
            :disabled="verified"
          >
          </v-text-field-->
         
  </v-list-item-title>
  <v-list-item-subtitle v-if="verified && user && user.name">
   {{user.phone}}
  </v-list-item-subtitle>
  <v-list-item-subtitle v-else-if="hint" class="grey--text text-center">
   {{hint}}
  </v-list-item-subtitle>
  
  </v-list-item-content>
  <template v-if="phone && isValid">
  <v-list-item-action v-if="verified || (isValid && !validate)" class="ml-0">
          <v-btn icon text color="success" style="height: auto"
                  ><v-icon>check</v-icon></v-btn
                >
  </v-list-item-action>
   <v-list-item-action v-if="phone && isValid && !verified && validate" class="ml-0 pb-3">
            <v-btn dense @click.stop="getCode" text icon color="primary" style="height: auto"
                  ><v-icon class="mr-2">published_with_changes</v-icon> <span v-if="!dense">Valideren</span></v-btn
                >
          
  </v-list-item-action>
  </template>
  </slot>
  <v-dialog dark v-model="dialog" width="400">
              <v-card color="primary" :loading="loading">
                <v-card-title class="justify-center">
                  SMS controle
                  <v-spacer></v-spacer>
                  <v-btn @click="dialog = false" icon><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text align="center" class="text-center py-5">
                  
              <otp-input  ref="otpInput" :length="4" :autofocus="true" :dark="true" class="mx-auto"
              v-model="code" color="primary" @finish="checkCode" style="max-width:200px"
              ></otp-input>

                 
                  
                  <v-card-title v-if="message">{{ message }}</v-card-title>
                  <div class="mt-5">
                    We hebben een 4 cijferige code in die gestuurd is naar <b>{{phone}}</b> om je telefoonnummer te controleren.
                  </div>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions v-if="false">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click.stop="checkCode" :loading="loading">
                    Controleren
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
 </v-list-item>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import OtpInput from '../components/otp/OtpInput.vue'
export default {
  components: {
    OtpInput
  },
  props: {
    value: {
      type: String,
      default: function () {
        return null;
      },
    },
    hint: {
      type: String,
      default: function () {
        return null;
      },
    },
    icon: {
      type: String,
      default: function () {
        return null;//"mdi-cellphone";
      },
    },
     color: {
      type: String,
      default: function () {
        return "primary";
      },
    },
    placeholder: {
      type: String,
      default: function () {
        return "Telefoonnummer";
      },
    },
    dense: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    validate: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
    force: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      message: null,
      code: null,
      verified: false,
      phone: null
    };
  },
  computed: {
     ...mapGetters(["user"]),
    isValid(){
      if (!this.phone) return false
      if (this.phone.length < 10) return false
      return this.$config.rules.mobile(this.phone) ? true : false
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    user(value){
        this.init()
        let self = this
        setTimeout(()=>{
          //if (self.$refs.phonefield) self.$refs.phonefield.focus()
        },100)
    },
    isValid(value, old){
     //if (old==false && value ==true && !this.verified) this.getCode()
    }
  },
  methods: {
     ...mapActions([
        'login','setModus','setUser'
      ]),
      ...mapMutations([
        'setPhone'
      ]),
    init(){
      this.code = null
      this.phone = this.user ? this.user.phone : null
      this.verified = (this.user && this.user._verified) ? true: false
    },
    check(phone){
        this.phone = phone
        if (this.isValid) return this.getCode()
    },
    open(){
      this.dialog = true
    },
    blur(){

      //if (!this.dialog) this.$emit('blur')
    },
    focus(){
      this.$emit('focus')
    },
    async resetUser(){
      if (!this.user) return false
      if (
          await this.$root.$confirm(
            "Ander telefoonnummer?",
            "Wil je met een ander telefoonnummer bestellen?",
            { yes: "Ja", cancel: "Nee" }
          )
          ) {
          this.setUser(null)
          this.$emit('reset')
        } else {
          
        }
    },
    async getCode() {
      if (!this.isValid) return false
      if (this.verified) return false
      
      let self = this
      this.loading = true;
      let response = await this.$http
          .post("/api/auth/signup", {
            phone: this.phone,
            force: this.force 
          })
      this.loading = false;
      if (response.data.error) return this.message = "Er is iets misgegaan bij het aanmelden, probeer het opnieuw." + response.data.error.message
      //if (response.data.status !== "OK") this.message = "Er is iets misgegaan";
      if (response.data.user && !this.validate){
          return this.$emit('select', response.data.user)
          //return this.setValid(response.data)
      } 
      //return console.log(this.validate)
      this.dialog = true;
    },
    async checkCode() {
      this.loading = true;
      let response = await this.$http.post("/api/auth/login", {
        phone: this.phone,
        code: this.code,
      });
      this.loading = false;
      if (response.status == 401){
        this.code = null
        return (this.message = "Ongeldige code ingevoerd voor " + this.phone);
      }
      this.setValid(response.data)
    },
    async setValid(data){
      data.user._verified = new Date()
      this.verified = true
      this.login(data)
      this.$emit("valid", data.user);
      this.dialog = false;
    }
  },
};
</script>
